var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { fluid: "", "grid-list-md": "" } },
    [
      _c("v-tabs", [_c("v-tab", [_vm._v("Corte de Servicio")])], 1),
      _c("v-divider"),
      _c(
        "v-layout",
        {
          staticStyle: { "padding-right": "10px" },
          attrs: { row: "", wrap: "" }
        },
        [
          _c(
            "v-flex",
            { attrs: { xs9: "", sm9: "", md4: "" } },
            [
              _c("v-autocomplete", {
                attrs: {
                  label: _vm.formFields.clientes.label,
                  items: _vm.clientesAll,
                  "item-text": _vm.formFields.clientes.formatItem,
                  "item-value": "id",
                  "data-vv-name": "selectedValue",
                  color: "primary",
                  clearable: true,
                  "no-data-text": "Sin resultados",
                  required: ""
                },
                model: {
                  value: _vm.formFields.clientes.value,
                  callback: function($$v) {
                    _vm.$set(_vm.formFields.clientes, "value", $$v)
                  },
                  expression: "formFields.clientes.value"
                }
              })
            ],
            1
          ),
          _c(
            "v-flex",
            { attrs: { xs2: "", sm2: "", md6: "" } },
            [
              _c(
                "v-layout",
                { attrs: { row: "" } },
                [
                  _c("v-flex", { attrs: { xs1: "", sm1: "", md1: "" } }, [
                    _c(
                      "div",
                      {
                        staticClass: "text-sm-center botones-filtros",
                        staticStyle: {
                          "padding-right": "20px",
                          "padding-left": "20px",
                          display: "block",
                          margin: "0 0 0 auto",
                          "margin-top": "15px"
                        }
                      },
                      [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function(ref) {
                                  var on = ref.on
                                  return [
                                    _c("v-icon", _vm._g({}, on), [
                                      _vm._v("report_problem")
                                    ])
                                  ]
                                }
                              }
                            ])
                          },
                          [
                            _c("span", [
                              _vm._v(
                                "Si desea cambiar de cliente, seleccionelo de la lista y de\n                click a 'Buscar'"
                              )
                            ])
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _c("v-flex", { attrs: { xs1: "", sm1: "", md2: "" } }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros" },
                      [
                        _c(
                          "v-btn",
                          { on: { click: _vm.showTable } },
                          [_c("v-icon", [_vm._v("search")]), _vm._v("Buscar ")],
                          1
                        )
                      ],
                      1
                    )
                  ]),
                  _c("v-flex", { attrs: { xs1: "", sm1: "", md2: "" } }, [
                    _c(
                      "div",
                      { staticClass: "text-sm-center botones-filtros" },
                      [
                        _c(
                          "v-btn",
                          { on: { click: _vm.clearFilters } },
                          [
                            _c("v-icon", [_vm._v("clear")]),
                            _vm._v("Limpiar\n            ")
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      !_vm.showTables
        ? _c("div", { staticStyle: { "text-align": "center" } }, [
            _c("div", { attrs: { id: "textEmpty" } }, [
              _vm._v("No ha seleccionado ningún cliente")
            ]),
            _c("img", { attrs: { src: require("@/assets/emptyIcon.png") } })
          ])
        : _c(
            "v-flex",
            {
              staticStyle: { "padding-right": "0px" },
              attrs: { xs12: "", sm6: "", md12: "" }
            },
            [
              _c(
                "div",
                {
                  staticStyle: { "padding-top": "6px", "padding-right": "0px" }
                },
                [
                  _c(
                    "v-btn",
                    {
                      staticStyle: { "padding-right": "20px" },
                      attrs: { color: "#ffe800" },
                      on: {
                        click: function($event) {
                          _vm.dialogConfirmacion = true
                        }
                      }
                    },
                    [
                      _c("span", { staticStyle: { color: "black" } }, [
                        _vm._v(_vm._s(_vm.action) + " Servicio")
                      ])
                    ]
                  )
                ],
                1
              ),
              _c("IntegrationLists", {
                attrs: { "integration-list": _vm.tablaDatos }
              })
            ],
            1
          ),
      _c("app-confirmacion", {
        attrs: {
          show: _vm.dialogConfirmacion,
          titulo: "Confirmación de Corte",
          mensaje: "Esta seguro de " + _vm.action + " este servicio?",
          textoBtnSi: "Confirmar",
          textoBtnNo: "Cancelar"
        },
        on: {
          modalConfirmationEmit: function($event) {
            return _vm.confirmCallback($event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }